import { useCallback } from "react"

type PillButtonType = {
  fromColor?: string
  toColor?: string
  label: string
  iconSrc: string
  iconWidth?: string
  iconHeight?: string
  buttonWidth?: string
  onClickHandle?: () => void
  isAuth?: boolean
}

export function PillButton(props: PillButtonType) {

  const onClickButton = useCallback(() => {
    if (!props.isAuth || !props.onClickHandle) return
    props.onClickHandle()
  }, [props])

  return (
    <div
      className={`h-[60px] rounded-[100px] ${props.buttonWidth ? 'w-[' + props.buttonWidth + ']' : 'w-full'}`}
      style={{ backgroundImage: `linear-gradient(to top, ${props.fromColor}, ${props.toColor})` }}
    >
      <button
        className={`flex items-center justify-center w-full h-full rounded-[100px] ${!props.isAuth && 'cursor-not-allowed'}`}
        onClick={onClickButton}
      >
        <img src={props.iconSrc} alt="" className="mr-[5px] w-[20px] desktop-xmd:w-[32px]" />
        <span className="text-white font-semibold">{props.label}</span>
      </button>
    </div>
  )
}